import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ✅ Get Shortlist
export async function loadShortlistApi(payload) {
  try {
    const fd = new FormData();

    fd.append("agency_id", payload.agency_id || "");
    fd.append("campaign_id", payload.campaign_id || "");

    const res = await axios.post(`${apiBaseUrl}shortlistapis/get_shortlist`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;

  } catch {
    return { status: false };
  }
}

// ✅ Add To Shortlist
export async function addToShortlistApi(payload) {
  try {
    const fd = new FormData();

    fd.append("agency_id", payload.agency_id || "");
    fd.append("campaign_id", payload.campaign_id || "");
    fd.append("influencer_id", payload.influencer_id || "");

    fd.append("inf_name", payload.inf_name || "");
    fd.append("inf_platform", payload.inf_platform || "");
    fd.append("inf_category", payload.inf_category || "");
    fd.append("inf_fans", payload.inf_fans || "");

    const res = await axios.post(`${apiBaseUrl}shortlistapis/add_shortlist`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;

  } catch {
    return { status: false };
  }
}

// ✅ Remove From Shortlist
export async function removeShortlistApi(agency_id,influencer_id) {
  try {
    const fd = new FormData();

    fd.append("agency_id", agency_id);
    fd.append("influencer_id", influencer_id);

    const res = await axios.post(`${apiBaseUrl}shortlistapis/remove_shortlist`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;

  } catch {
    return { status: false };
  }
}

export async function connectNowApi(payload) {
  try {
    const fd = new FormData();

    fd.append("agency_id", payload.agency_id || "");
    fd.append("influencer_id", payload.influencer_id || "");

    const res = await axios.post(
      `${apiBaseUrl}shortlistapis/connect_now`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return res.data;

  } catch (err) {
    console.error("connectNowApi error:", err);
    return { status: false };
  }
}
